/**
 * Поток событий с сервера.
 *
 * `EventSource`, а не WebSocket: трафик односторонний, переподключение и
 * возобновление по `Last-Event-ID` браузер делает сам, а `401` на первом `GET`
 * виден клиенту нормально — в отличие от WebSocket, где браузер скрывает код
 * ответа при неудачном upgrade и приходится изобретать внутриполосный отказ.
 */
export function subscribe(
  onEvent: (kind: string, data: unknown) => void,
): () => void {
  let source: EventSource | null = null;
  let stopped = false;

  const open = () => {
    if (stopped) return;
    source = new EventSource("/api/events");
    source.addEventListener("message", (event) => {
      try {
        onEvent("message", JSON.parse(event.data));
      } catch {
        // Мусор в потоке не повод рвать подписку.
      }
    });
    source.addEventListener("camera", (event) => {
      try {
        onEvent("camera", JSON.parse((event as MessageEvent).data));
      } catch {
        /* пропускаем */
      }
    });
    // EventSource переподключается сам, но если сервер отвечает 401 — он будет
    // долбиться в закрытую дверь. Поэтому закрываем и оставляем это на
    // следующую загрузку страницы.
    source.addEventListener("error", () => {
      if (source?.readyState === EventSource.CLOSED) {
        source = null;
      }
    });
  };

  open();

  return () => {
    stopped = true;
    source?.close();
  };
}
